import { trafficSourceAnalysis } from './trafficSourceAnalysis';

export const trafficSourceInfo = trafficSourceAnalysis();
